import React, { useContext, useMemo } from 'react';
import { createStore } from 'redux';
import merge from 'lodash/merge';
import { getUrl } from '@atlaskit/linking-common';
import { extractSmartLinkEmbed } from '@atlaskit/link-extractors';
import { cardReducer } from './reducers';
import { SmartCardContext } from './state/context';
import CardClient from './client';
export function SmartCardProvider(_ref) {
  var storeOptions = _ref.storeOptions,
    customClient = _ref.client,
    customAuthFlow = _ref.authFlow,
    children = _ref.children,
    renderers = _ref.renderers,
    isAdminHubAIEnabled = _ref.isAdminHubAIEnabled,
    product = _ref.product,
    shouldControlDataExport = _ref.shouldControlDataExport,
    isPreviewPanelAvailable = _ref.isPreviewPanelAvailable,
    openPreviewPanel = _ref.openPreviewPanel;
  var parentContext = useContext(SmartCardContext);
  var defaultInitialState = useMemo(function () {
    return {};
  }, []);
  var _ref2 = storeOptions || {
      initialState: defaultInitialState
    },
    initialState = _ref2.initialState;
  var store = useMemo(function () {
    return createStore(cardReducer, initialState);
  }, [initialState]);
  var providerValue = useMemo(function () {
    var client = customClient || new CardClient();

    // If product is passed into provider, set it on the client if setProduct is supported
    if (product && client.setProduct) {
      client.setProduct(product);
    }
    var authFlow = customAuthFlow || 'oauth2';
    var getPreview = function getPreview(url, _platform) {
      var cardState = getUrl(store, url);
      return cardState.details ? extractSmartLinkEmbed(cardState.details) : undefined;
    };
    return {
      renderers: renderers,
      store: store,
      prefetchStore: {},
      connections: {
        client: client
      },
      config: {
        authFlow: authFlow
      },
      extractors: {
        getPreview: getPreview
      },
      isAdminHubAIEnabled: isAdminHubAIEnabled,
      product: product,
      shouldControlDataExport: shouldControlDataExport,
      isPreviewPanelAvailable: isPreviewPanelAvailable,
      openPreviewPanel: openPreviewPanel
    };
  }, [customAuthFlow, customClient, isAdminHubAIEnabled, isPreviewPanelAvailable, openPreviewPanel, product, renderers, shouldControlDataExport, store]);
  var value = useMemo(function () {
    return merge({}, parentContext || providerValue, {
      isPreviewPanelAvailable: isPreviewPanelAvailable,
      openPreviewPanel: openPreviewPanel
    });
  }, [parentContext, providerValue, isPreviewPanelAvailable, openPreviewPanel]);
  return /*#__PURE__*/React.createElement(SmartCardContext.Provider, {
    value: value
  }, children);
}
export default SmartCardProvider;